import React, {useState} from "react";
import {PageTitleHeader, RoundedTable, SquareButton} from "../../components/index.jsx";
import {useRequest} from "../../utils/hooks.jsx";
import {deliveryProviderProjection, pageSize} from "./consts.js";
import {columns} from "./columns.jsx";
import {ConfigProvider} from "antd";
import "./admin-delivery-provider.css";
import {openWindow} from "../../http/WindowOpener.jsx";
import {ADMIN_PATH_NAME} from "../consts.jsx";

export const AdminDeliveryProvider = ({history}) => {
    const [currentPage, setCurrentPage] = useState(1);

    const [deliveryProviders = {}, isLoading] = useRequest(
        "/admin/api/deliveryProviders/search",
        "POST",
        {
            page: currentPage,
            pageSize: pageSize,
            projection: deliveryProviderProjection
        },
        [currentPage]
    );

    return (
        <div className="delivery-providers-page">
            <ConfigProvider direction="rtl">
                <PageTitleHeader showBack={false}>ספקי שילוח</PageTitleHeader>

                <SquareButton
                    className="delivery-provider-creation-btn"
                    onClick={() => history.push(`/${ADMIN_PATH_NAME}/shippingProvider/upload`)}>
                    הוספת ספק שילוח
                </SquareButton>

                <RoundedTable
                    className="delivery-provider-table"
                    scroll={{x: 1240}}
                    pagination={{
                        position: ["bottomRight"],
                        showSizeChanger: false,
                        defaultPageSize: pageSize,
                        total: deliveryProviders?.totalCount,
                        showTotal: total => <span>סה״כ {total}</span>,
                        onChange: (page, pageSize) => setCurrentPage(page)
                    }}
                    loading={isLoading}
                    dataSource={deliveryProviders?.deliveryProviders ?? []}
                    columns={columns(currentPage, deliveryProvider =>
                        history.push(
                            `/${ADMIN_PATH_NAME}/shippingProvider/upload/${deliveryProvider?.deliveryProviderId}`
                        )
                    )}
                />
            </ConfigProvider>
        </div>
    );
};
